//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const cronList = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getCron(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/cron-procedure/cron`, obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }
  return {
    getCron
  };
};

export default cronList;
